export default __webpack_public_path__ + "static/media/fingerprint.d1afe176.png";